<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-04 10:56:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-11 13:40:26
-->
<template>
  <div class="DetailedfulTransfer">
    <Cashier :isJust="true" ></Cashier>
  </div>
</template>
<script>
import Cashier from '@/components/Cashier.vue';

export default {
  name: 'DetailedfulTransfer',
  components: {
    Cashier,
  },
  data() {
    return {

    };
  },
  mounted() {
    console.log(this.$router.currentRoute.query.data);
  },
};
</script>
<style scoped>
</style>
